(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["calb-contact-form"] && !Shopify.designMode) return;
  try {
    function calbContactProjects(){
    document.querySelectorAll('[data-ce-reason]').forEach(select=>{
      if(select.dataset.ceReady)return;
      select.dataset.ceReady='true';
      const form=select.closest('form');
      function update(){
        [['commission','[data-ce-commission]'],['event','[data-ce-event]']].forEach(([value,selector])=>{
          const group=form.querySelector(selector);
          if(!group)return;
          const active=select.value===value;
          group.hidden=!active;group.disabled=!active;
          group.querySelectorAll('[data-ce-required]').forEach(input=>input.required=active);
        });
        const budget=form.querySelector('[data-ce-budget]');
        const showBudget=select.value==='commission'||select.value==='event';
        if(budget){budget.hidden=!showBudget;budget.querySelector('input').disabled=!showBudget;}
      }
      const project=new URLSearchParams(window.location.search).get('projet');
      if(project&&Array.from(select.options).some(option=>option.value===project))select.value=project;
      select.addEventListener('change',update);
      document.querySelectorAll('[data-ce-project]').forEach(link=>link.addEventListener('click',()=>{select.value=link.dataset.ceProject;update();}));
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',calbContactProjects);else calbContactProjects();
  document.addEventListener('shopify:section:load',calbContactProjects);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["calb-preview-links"] && !Shopify.designMode) return;
  try {
    function calbPreviewLinks(){
    const preview=document.querySelector('[data-calb-preview]');
    if(!preview)return;
    document.querySelectorAll('a[href]').forEach(a=>{
      if(a.closest('.calb-artist'))return;
      const raw=a.getAttribute('href');
      if(!raw||raw.startsWith('#'))return;
      const href=new URL(a.href,window.location.origin);
      if(href.origin!==window.location.origin)return;
      if(href.hash||href.search)return;
      if(/\/pages\/lartiste\/?$/.test(href.pathname))a.href=preview.dataset.artistUrl;
      if(/\/pages\/contact\/?$/.test(href.pathname))a.href=preview.dataset.contactUrl;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',calbPreviewLinks);else calbPreviewLinks();
  document.addEventListener('shopify:section:load',calbPreviewLinks);
  } catch(e) { console.error(e); }
})();

})();
